import { render, staticRenderFns } from "./firma-individual-formalizacion.vue?vue&type=template&id=526a65a6&scoped=true&"
import script from "./firma-individual-formalizacion.component.ts?vue&type=script&lang=ts&"
export * from "./firma-individual-formalizacion.component.ts?vue&type=script&lang=ts&"
import style0 from "./firma-individual-formalizacion.vue?vue&type=style&index=0&id=526a65a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a65a6",
  null
  
)

export default component.exports